import React, { useContext } from 'react';
import {
  CCard,
  CCardHeader,
  CCardBody,
  CLabel,
  CFormGroup,
  CCardTitle,
  CTooltip,
  CImg,
  CInput,
} from '@coreui/react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import classNames from 'classnames';
import Select from '../../shared/components/form/select/Select';
import tooltip from '../../assets/images/tool_tip.svg';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';
import { CustomizationFormProps } from '../types';

export const PROOF_OF_DELIVERY_OPTIONS = [
  {
    value: 'none',
    label: 'No Capture',
  },
  {
    value: 'signature',
    label: 'Signature Capture',
  },
  {
    value: 'photo',
    label: 'Photo Capture',
  },
  {
    value: 'both',
    label: 'Photo/Signature Capture',
  },
];

const ProofOfDelivery = () => {
  const labels = useContext(ConfigContext);
  const formik = useFormikContext();

  const errors = formik.errors as CustomizationFormProps;

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  return (
    <CCard className="glympser-container--roundedWithShadow">
      <CCardHeader className="glympser-roundedTop">
        <div className="d-flex align-items-center justify-content-between">
          <CCardTitle className="m-0">
            Proof of Delivery
            <CTooltip placement="top"
                      content={`Allows ${labels.agent.toLowerCase()} to Capture your customer’s signature or take and add a photo before completing a ${labels.task.toLowerCase()}`}>
              <CImg src={tooltip} className="ml-2 glympser-toolTip" />
            </CTooltip>
          </CCardTitle>
        </div>
      </CCardHeader>
      <CCardBody>
        <CFormGroup>
          <CLabel htmlFor="capture">
            Capture Type
            <CTooltip placement="top"
                      content={`Signature Capture allows you to get a signature from the customer upon ${labels.task.toLowerCase()} completion. Photo Capture allows your ${labels.agent.toLowerCase()} to take an image of work done upon ${labels.task.toLowerCase()} completion.`}>
              <CImg src={tooltip} className="ml-2 glympser-toolTip" />
            </CTooltip>
          </CLabel>
          <Select
            isMulti={false}
            name="capture"
            id="capture"
            options={PROOF_OF_DELIVERY_OPTIONS}
            className={classNames({ 'is-invalid': isInvalid('capture') })}
            classNamePrefix="select"
            {...formik.getFieldProps('capture')}
            onBlur={() => formik.setFieldTouched('capture', true, true)}
            onChange={(values) => formik.setFieldValue('capture', values)}
          />
          {isInvalid('capture') && <div className="invalid-feedback">{errors.capture}</div>}
        </CFormGroup>
        <CFormGroup>
          <CLabel htmlFor="name">Label</CLabel>
          <CInput
            id="confirmationPhotoLabel"
            type="text"
            placeholder="Confirmation Photo Label"
            name="confirmationPhotoLabel"
            className={classNames({ 'is-invalid': isInvalid('confirmationPhotoLabel') })}
            {...formik.getFieldProps('confirmationPhotoLabel')}
          />
          {isInvalid('confirmationPhotoLabel') &&
            <div className="invalid-feedback">{errors.confirmationPhotoLabel}</div>}
        </CFormGroup>
      </CCardBody>
    </CCard>
  );
};

export default ProofOfDelivery;
